<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2f2">CONTENTS</h2>
<p class="toc" id="rdedi"><span href="#/text/9780062376886_Dedication#dedi" title="Link target outside of Sample">Dedication</span></p>
<p class="toc" id="repi"><span href="#/text/9780062376886_Epigraph#epi" title="Link target outside of Sample">Epigraph</span></p>
<p class="toc1" id="rch1"><a href="#/text/9780062376886_Chapter_1#ch1">Chapter 1</a></p>
<p class="toc" id="rch2"><span href="#/text/9780062376886_Chapter_2#ch2" title="Link target outside of Sample">Chapter 2</span></p>
<p class="toc" id="rch3"><span href="#/text/9780062376886_Chapter_3#ch3" title="Link target outside of Sample">Chapter 3</span></p>
<p class="toc" id="rch4"><span href="#/text/9780062376886_Chapter_4#ch4" title="Link target outside of Sample">Chapter 4</span></p>
<p class="toc" id="rch5"><span href="#/text/9780062376886_Chapter_5#ch5" title="Link target outside of Sample">Chapter 5</span></p>
<p class="toc" id="rch6"><span href="#/text/9780062376886_Chapter_6#ch6" title="Link target outside of Sample">Chapter 6</span></p>
<p class="toc" id="rch7"><span href="#/text/9780062376886_Chapter_7#ch7" title="Link target outside of Sample">Chapter 7</span></p>
<p class="toc1" id="rata"><span href="#/text/About_the_Author#ata" title="Link target outside of Sample">About the Author</span></p>
<p class="toc" id="rpra"><span href="#/text/9780062376886_Praise#pra" title="Link target outside of Sample">Praise</span></p>
<p class="toc" id="ralso"><span href="#/text/9780062376886_Also_by#also" title="Link target outside of Sample">Also by Tobias Wolff</span></p>
<p class="toc" id="back"><span href="#/text/9780062376886_Back_Ad#rback" title="Link target outside of Sample">Back Ad</span></p>
<p class="toc" id="rcopy"><span href="#/text/9780062376886_Copyright#copy" title="Link target outside of Sample">Copyright</span></p>
<p class="toc" id="ratp"><span href="#/text/About_the_Publisher#atp" title="Link target outside of Sample">About the Publisher</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062376886_Contents.vue?4aa3a0f8